
import Sichicon from "../images/Sichicon";

export const Alphabet = "АÄБВГДЕЄЖЗІЇИЙКЛМНОПРСТУФХЦЧШЩЮЯ_ABCDEFGHIJKLMNOÖPQRSTUÜVWXYZабвгдеєжзіїийклмнопрстуфхцчшщьюяaäbcdefghijklmnoöpqrsßtuüvwxyz1234567890,.-+=!?@#$%^*()[]{}|;:'\"/~>\\";
export const numAlph = {"!": 138,
'"': 156,
"#": 141,
"$": 142,
"%": 143,
"'": 155,
"(": 146,
")": 147,
"*": 145,
"+": 136,
",": 133,
"-": 135,
".": 134,
"/": 157,
0: 132,
1: 123,
2: 124,
3: 125,
4: 126,
5: 127,
6: 128,
7: 129,
8: 130,
9: 131,
":": 154,
";": 153,
"=": 137,
">": 159,
"?": 139,
"@": 140,
A: 33,
B: 34,
C: 35,
D: 36,
E: 37,
F: 38,
G: 39,
H: 40,
I: 41,
J: 42,
K: 43,
L: 44,
M: 45,
N: 46,
O: 47,
P: 49,
Q: 50,
R: 51,
S: 52,
T: 53,
U: 54,
V: 56,
W: 57,
X: 58,
Y: 59,
Z: 60,
"[": 148,
"\\": 160,
"]": 149,
"^": 144,
_: 32,
a: 93,
b: 95,
c: 96,
d: 97,
e: 98,
f: 99,
g: 100,
h: 101,
i: 102,
j: 103,
k: 104,
l: 105,
m: 106,
n: 107,
o: 108,
p: 110,
q: 111,
r: 112,
s: 113,
t: 115,
u: 116,
v: 118,
w: 119,
x: 120,
y: 121,
z: 122,
"{": 150,
"|": 152,
"}": 151,
"~": 158,
"Ä": 1,
"Ö": 48,
"Ü": 55,
"ß": 114,
"ä": 94,
"ö": 109,
"ü": 117,
"Є": 7,
"І": 10,
"Ї": 11,
"А": 0,
"Б": 2,
"В": 3,
"Г": 4,
"Д": 5,
"Е": 6,
"Ж": 8,
"З": 9,
"И": 12,
"Й": 13,
"К": 14,
"Л": 15,
"М": 16,
"Н": 17,
"О": 18,
"П": 19,
"Р": 20,
"С": 21,
"Т": 22,
"У": 23,
"Ф": 24,
"Х": 25,
"Ц": 26,
"Ч": 27,
"Ш": 28,
"Щ": 29,
"Ю": 30,
"Я": 31,
"а": 61,
"б": 62,
"в": 63,
"г": 64,
"д": 65,
"е": 66,
"ж": 68,
"з": 69,
"и": 72,
"й": 73,
"к": 74,
"л": 75,
"м": 76,
"н": 77,
"о": 78,
"п": 79,
"р": 80,
"с": 81,
"т": 82,
"у": 83,
"ф": 84,
"х": 85,
"ц": 86,
"ч": 87,
"ш": 88,
"щ": 89,
"ь": 90,
"ю": 91,
"я": 92,
"є": 67,
"і": 70,
"ї": 71};
export const allowedSet = new Set(Alphabet);
export const MAX_MESSAGE_LENGTH = 477;
export const MAX_SECRETCODE_LENGTH = 77;

export const infoData = [
    {
      title: "How to use Messenger?",
      content: <ul>
        <li> To use the messenger, you need to create your own account. </li>
        <li> An account is created using an email, nickname, picture, and password that only you know. </li>
        <li> Chats for communication are created by searching for interlocutors in the <b>Search users</b> field by their nickname or email. </li>
        <li> Messages typed in the <b>Unencrypted Message</b> field are sent in WRITE mode by clicking the send icon. </li>
        <li> In messages, you can send images in jpeg, jpg, png formats with a size of no more than 1MB.</li>
        <li> Group chats are created by filling out the form ➕ <b>Create Group Chat </b></li>
        <li> Only the administrator can add and group members. To become a group member, you must first contact the administrator.</li>
        <li> If the administrator removes himself from the group, the group is liquidated</li>
        <li> The creator of a chat becomes its administrator. It is allowed to administrate no more than 3 chats. </li>
        <li> Messages are sent by typing text in the <b>Unencrypted Message</b> field and clicking the <span className=' close_button message-bubble'> <Sichicon focusable="false" aria-hidden="true" /> </span><b>Send message</b> button.  </li>
        <li> Messages and pictures can be encrypted by you by adding a secret key in the <b>Secret Key</b> field. </li>
        <li> The secret key is invented by you, known only to you, and not stored anywhere else. </li>
        <li> To create messages, as well as the secret key, letters of the English alphabet and the alphabet of your choice, as well as numbers and punctuation marks, are used. </li>
        <li> The <b>&#60;</b>, <b>&#62;</b> characters are not used.</li>
        <li> The secret key must be between 9 and 69 characters long. </li>
        <li> To decrypt the message or picture, the user must know the secret key. </li>
        <li> To read the received encrypted message, you need to drag it in READ mode to the <b>Drop here an encrypted message</b> field and enter the secret key with which the message was encrypted in the <b>Secret Key</b> field.</li>
        <li> If the secret key is lost, it is impossible to decrypt the encrypted message. </li>
        <li> Messenger Sich can be used as your own, secure, quick-access credentials storage </li>
        <li> <b>Without knowing the secret key, no one will ever be able to read your messages.</b></li>
        <li> Voice calling functionality is under development</li>
        <li> You can send suggestions and comments regarding the messenger to our email.</li>
      </ul>
    },
    {
      title: "App Guide",
      content: <ul>
        <li> Install the App <span className=' close_button message-bubble'> <Sichicon focusable="false" aria-hidden="true" /> </span> by selecting <b>Install App</b> in the <b>Settings</b> menu. </li>
        <li> Sich Messenger takes up minimal memory on your device and is extremely battery-efficient. </li>
        <li> The app updates automatically, ensuring you have access to the latest features every time you launch it. </li>
        <li> Thanks to the installed application and PWA technology, even without an internet connection, you can decrypt and read messages. </li>
        <li> Thanks to background notifications in the installed application, you will stay connected even if the browser or messenger is closed. </li>
      </ul>
    },
    {
      title: "Your Privacy",
      content: <ul>
        <li> Registering in the Sich messenger only via email and nickname provides you with maximum confidentiality.</li>
        <li> The data you operate with is stored on the server in the amount necessary to provide communication services. The data is stored on the server in a format that ensures fast delivery and synchronization between your devices.</li>
        <li> Access to the database is strictly limited and is carried out only for technical support of the service.</li>
        <li> Only you know the content of your messages. </li>
        <li> You yourself encrypt your messages and only you decide who, knowing the secret key, will be able to read them.</li> 
        <li> Without knowing the secret key, it is impossible to decrypt your messages.</li>
        <li> You yourself invent a secret key, which you can later inform anyone in any way.</li>
        <li> The encrypted messages you create exist only in an encrypted state. </li>
        <li> Keep your secret keys in a secure place. </li>
        <li> The content of your correspondence is not transferred to third parties, except in cases provided for by law.</li>
        <li> All requests between your device and the server are protected by the HTTPS protocol.</li>
        <li> For authorization and access to chats, the messenger uses modern security tokens (digital keys). </li>
        <li> The transmission of messages that you have already encrypted occurs via the encrypted HTTPS/SSL protocol, which cannot be intercepted.</li>
        <li> Only chat participants have access to chat messages.</li>
        <li> When you delete a message, it immediately disappears from your screen and the screen of your interlocutor, and is deleted from the database."</li>
        <li> Your nickname and email address, which are your only credentials, are not shared with third parties and are not used for advertising. </li>
        <li> Messages can be decrypted even without an internet connection.</li>
        <li> This is so important that we emphasize it again: "Without knowing the secret key, no one will ever be able to read your messages."</li>
        <li> Local data on the device is protected by the security mechanisms of your operating system and is completely deleted when you clear your browser cache.</li>
        <li> Photos are stored in Cloudinary's professional secure storage. Only chat participants have access to them.</li>    </ul>
    },
    {
      title: "Terms & Safety",
      content: <ul>
        <li> All interface elements, design and program code are the intellectual property of the developer. Copying or reverse engineering of the code without the consent of the author is prohibited. </li>
        <li> The user is fully responsible for the information he transmits. The distribution of malicious software, phishing links and content that violates the law is prohibited. </li>
        <li> Any automated activity, mass mailings or the use of scripts for spam are prohibited.</li>
        <li> The administration reserves the right to suspend access to the account in case of suspicious activity or violation of the rules of use without prior notice.</li>
        <li> Attempts to interfere with the operation of the messenger, manipulation of code or use of vulnerabilities to obtain unauthorized access will result in account blocking. </li>
        <li> The service is provided on an "AS IS" basis. The administration does not guarantee 100% availability of the server and does not assume responsibility for data loss in case of technical failures or force majeure circumstances. </li>
        <li> The user agrees not to use the messenger for any illegal activities, including but not limited to fraud, distribution of prohibited content or violation of third parties' rights. </li>
        <li> The administration reserves the right to change these terms of use at any time without prior notice. Continued use of the messenger after changes indicates acceptance of new terms.</li>
      </ul>  
    },
    {
      title: "Contacts",
      content: <ul>
        <li> <b>Sich Messenger-Team: </b>Seit der Gründung ausschließlich remote.   </li>
        <li> <b> Infrastruktur: </b> Deutschland, EU.  </li>
        <li> <b> Anfragen:  </b> admin@sich.app  </li>
        <li> <b> Nur du kennst den Inhalt deiner Nachrichten.</b> </li>
        <li> © 2026 Sich </li>
      </ul>  
    }
  ];